<template>
    <form id="frm_action_matrix">
        <div class="matrix-box mt-3 pl-3">
            <div class="matrix-layout">
                <div class="matrix-table-wrap">
                    <table id="matrix-table">
                        <thead>
                            <tr>
                                <td class="head-color-blank" colspan="1" rowspan="1"></td>
                                <td class="head-color" colspan="1" rowspan="1" v-for="(item, index) in roundArr" :key="`headColor-${index}`">
                                    <div>{{ `Round ${item}` }}</div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in dataMatrix" :key="`bodyData-${index}`">
                                <td class="body-color" rowspan="1" colspan="1">
                                    <div><b>{{ item.part_number }}</b></div>
                                    <div v-if="dataMatrix.length > 0 && dataMatrix[index]">
                                        <div v-if="dataMatrix[index].user">{{ dataMatrix[index].user.fullname }}</div>
                                        <div>(Owner {{ dataMatrix[index].part }})</div>
                                    </div>
                                </td>
                                <td rowspan="1" colspan="1" v-for="(j, ind) in roundArr" :key="`bodyValue-${ind}`" @click="dataBookRound[index] && dataBookRound[index][ind] ? showPopupChooseDate(dataBookRound[index][ind], dataMatrix[index]) : null">
                                    <div v-if="dataBookRound[index] && dataBookRound[index][ind]" class="d-flex flex-column">
                                        <div class="align-self-start col-12"><b>{{dataBookRound[index][ind].ordinal}}</b></div>
                                        <div class="col-12" v-if="dataBookRound[index][ind].status">
                                            <div v-if="dataBookRound[index][ind].week">
                                                <span>{{ getWeekDisplayLabel(dataBookRound[index][ind].week) }}</span>
                                                <span v-if="!$commonFuction.isEmpty(dataBookRound[index][ind].week_1)"> - {{ getWeekDisplayLabel(dataBookRound[index][ind].week_1) }}</span>
                                            </div>
                                            <div v-else>
                                                {{$constants.BOOKING_STATUS[dataBookRound[index][ind].status]}}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div  class="week-not-chosen">
                    <h3>WEEK NOT CHOSEN</h3>
                    <div class="week-not-chosen-table-wrap">
                        <table class="week-not-chosen-table">
                            <thead>
                                <tr>
                                    <th>Week</th>
                                    <th>Maintainance</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="week in maintenanceWeekOptions" :key="getWeekKey(week)">
                                    <td>{{ week.name }}</td>
                                    <td class="maintenance-cell">
                                        <input type="checkbox" :checked="!!week.is_maintenance" @change="toggleMaintenance(week, $event)" />
                                    </td>
                                </tr>
                                <tr v-if="maintenanceWeekOptions.length === 0">
                                    <td class="empty-week-text" colspan="2">All weeks are already used in booking rounds.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            
            <Dialog header="Choose a time" :visible.sync="showPopup" :style="{width: '50vw'}" >
                <form id="frm_action_week">
                    <p>Choose a time for this round:</p>
                    <div>
                        <div>
                            <label class="p-col-fixed txt-right">Round</label>
                            <div class="p-col">
                                <InputText type="text" class="" v-model="dataPopup.round" :disabled="true"/>
                            </div>
                        </div>
                        
                        <div>
                            <label class="p-col-fixed txt-right" style="text-transform: capitalize;">Owner {{dataPopup.part.part_number}}</label>
                            <div class="p-col">
                                <InputText type="text" class="" v-model="dataPopup.part.name" :disabled="true"/>
                            </div>
                        </div>
                        
                        <div class="mb-4">
                            <label class="p-col-fixed txt-right txt-required">Week</label>
                            <div class="p-col box_select-maxtrict">
                                <v-select  multiple style=" bottom: 10%;padding-right: 0px !important;" title="Week" class="w-100 pr-5 mb-4" placeholder="Choose" v-model="dataPopup.week" :options="popupWeekOptions" label="name"  >
                                    <span slot="no-options" @click="$refs.select.open = false">
                                        Empty data
                                    </span>
                                </v-select>
                                <input class="input_tmp_validator" id="week_valid">
                            </div>
                        </div>
                    </div>
                    
                </form>
                <template #footer>
                    <Button label="Cancel" icon="pi pi-times" class="p-button-secondary" @click="showPopup = false"/>
                    <Button label="Confirm" icon="pi pi-check" @click="confirmPopup"/>
                </template>
            </Dialog>
        </div>
    </form>
</template>
  
<script>
import DataServices from '@/core/DataServices';
import moment from "moment-timezone";
export default {
    name: "matrixComponent",
    components: {
    },
    props: {
      value: Array,
      property: Object,
      listUid: Array,
      formula: String,
      dataColor: Array,
      dataBook: Array,
      propertyWeeks: Array,
      show: Boolean,
      mode: String,
      booking_id: String,
      roundArr: Array
    },
    async created() {
        this.dataMatrix = this.$props.value;
        this.dataBookRound = this.dataBook;
        console.log("this.dataBookRound11111111", this.dataBookRound);
        console.log("this.roundArr", this.roundArr);
        console.log("this.dataMatrix", this.roundArr);
        await this.getListWeek();
        await this.getMaintenanceVisits();
    },
    watch: {
        value: {
            deep: true,
            handler(val) {
                this.dataMatrix = val ?? [];
            }
        },
        dataBook: {
            deep: true,
            handler(val) {
                this.dataBookRound = val ?? [];
            }
        },
        propertyWeeks: {
            deep: true,
            async handler() {
                await this.getMaintenanceVisits();
            }
        },
        property: {
            deep: true,
            async handler() {
                await this.getMaintenanceVisits();
            }
        },
        'dataPopup.week': {
            deep: false,
            handler(val) {
                if (this.skipPopupWeekWatcher) {
                    this.skipPopupWeekWatcher = false;
                    this.previousPopupWeeks = [...(val ?? [])];
                    return;
                }
                const nextWeeks = [...(val ?? [])];
                const previousWeeks = [...(this.previousPopupWeeks ?? [])];
                const removedWeeks = previousWeeks.filter((week) => !nextWeeks.some((item) => this.isSameWeek(item, week)));
                const blockedWeek = removedWeeks.find((week) => !this.canRemoveAssignedWeek(week, this.dataPopup.uid));
                if (blockedWeek) {
                    this.$toast.add({
                        severity: 'warn',
                        summary: 'Warning',
                        detail: 'Only weeks with status "Not plan yet" can be removed.',
                        life: 3000
                    });
                    this.skipPopupWeekWatcher = true;
                    this.dataPopup.week = previousWeeks;
                    return;
                }
                this.previousPopupWeeks = nextWeeks;
            }
        }
    },
    computed: {
        maintenanceWeekOptions() {
            return (this.maintenanceVisits ?? [])
                .map((visit) => ({
                    ...visit,
                    date_start: visit.visit_start,
                    date_end: visit.visit_end,
                    name: `Week ${visit.week_number} (${this.getFilterDate(visit.visit_start)} - ${this.getFilterDate(visit.visit_end)})`
                }))
                .filter((week) => !this.isWeekAssigned(week));
        },
        popupWeekOptions() {
            const mergedWeeks = [...(this.listWeek ?? []), ...(this.dataPopup.original_week ?? [])];
            const mapWeeks = new Map();
            mergedWeeks.forEach((week) => {
                const normalizedWeek = this.normalizeWeek(week);
                const key = this.getWeekKey(normalizedWeek);
                if (key && !mapWeeks.has(key)) {
                    mapWeeks.set(key, normalizedWeek);
                }
            });
            return Array.from(mapWeeks.values());
        }
    },
    data() {
      return {
        dataArr: [1,2,3,4,5],
        dataBookRound: [],
        dataMatrix: [],
        time_zone_local : moment.tz.guess(true),
        dataPopup: {
            id: null,
            ordinal: null,
            part_id: null,
            uid: null,
            round: null,
            part: {
                part_number: null,
                name: null,
            },
            week: [],
            original_week: []
        },
        showPopup: false,
        listWeek: [],
        maintenanceVisits: [],
        visitRecords: [],
        previousPopupWeeks: [],
        skipPopupWeekWatcher: false
      };
    },
    methods: {
        normalizeWeek(week) {
            if (!week) {
                return null;
            }
            const sourceWeek = week?.week ?? week;
            const weekNumber = sourceWeek?.week_number ?? week?.week_number ?? null;
            const dateStart = sourceWeek?.date_start ?? week?.date_start ?? week?.visit_start ?? null;
            const dateEnd = sourceWeek?.date_end ?? week?.date_end ?? week?.visit_end ?? null;
            const fallbackName = (weekNumber && dateStart && dateEnd)
                ? `Week ${weekNumber} (${this.getFilterDate(dateStart)} - ${this.getFilterDate(dateEnd)})`
                : null;

            return {
                id: sourceWeek?.id ?? week?.id ?? null,
                index_week_id: sourceWeek?.index_week_id ?? week?.index_week_id ?? null,
                week_number: weekNumber,
                date_start: dateStart,
                date_end: dateEnd,
                name: week?.name ?? fallbackName
            };
        },
        getWeekDisplayLabel(week) {
            const normalizedWeek = this.normalizeWeek(week);
            if (!normalizedWeek) {
                return '';
            }
            if (normalizedWeek.name) {
                return normalizedWeek.name;
            }
            if (normalizedWeek.week_number && normalizedWeek.date_start && normalizedWeek.date_end) {
                return `Week ${normalizedWeek.week_number} (${this.getFilterDate(normalizedWeek.date_start)} - ${this.getFilterDate(normalizedWeek.date_end)})`;
            }
            return 'Week';
        },
        getWeekIdentifier(week) {
            if (!week) {
                return null;
            }
            if (week?.index_week_id) {
                return `index:${week.index_week_id}`;
            }
            if (week?.id) {
                return `id:${week.id}`;
            }
            if (week?.date_start && week?.date_end) {
                return `${moment(week.date_start).format('YYYY-MM-DD')}_${moment(week.date_end).format('YYYY-MM-DD')}`;
            }
            return null;
        },
        getVisitRecordForWeek(week, ownerUid = null) {
            const weekIdentifier = this.getWeekIdentifier(week);
            if (!weekIdentifier) {
                return null;
            }
            const matchedVisits = (this.visitRecords ?? []).filter((visit) => {
                const visitIdentifier = this.getWeekIdentifier({
                    index_week_id: visit?.index_week_id,
                    date_start: visit?.visit_start,
                    date_end: visit?.visit_end
                });
                return visitIdentifier === weekIdentifier;
            });
            if (matchedVisits.length === 0) {
                return null;
            }
            if (ownerUid) {
                const ownerVisit = matchedVisits.find((visit) => visit?.owner_id === ownerUid || visit?.uid === ownerUid);
                if (ownerVisit) {
                    return ownerVisit;
                }
            }
            return matchedVisits[0];
        },
        canRemoveAssignedWeek(week, ownerUid) {
            const visitRecord = this.getVisitRecordForWeek(week, ownerUid);
            if (!visitRecord) {
                return true;
            }
            return visitRecord.status === 'ST001';
        },
        async getVisitRecords() {
            if (!this.property?.id) {
                this.visitRecords = [];
                return;
            }
            let {data} = await this.$apollo.query({
                query: DataServices.getList('visit',{"fields" : `id index_week_id week_number visit_start visit_end is_maintenance status type owner_id uid`}),
                variables: {
                    where_key: {
                        deleted: {_eq: false},
                        property_id: {_eq: this.property?.id}
                    },
                    orderBy:[{visit_start : 'asc'}]
                },
                fetchPolicy: "network-only"
            });
            this.visitRecords = data[Object.keys(data)] ?? [];
        },
        getWeekKey(week) {
            return week?.index_week_id || week?.id || week?.local_key || `${week?.date_start}_${week?.date_end}`;
        },
        emitMaintenanceUpdate() {
            this.$emit("updateMaintenance", this.maintenanceWeekOptions);
        },
        isSameWeek(weekA, weekB) {
            if (!weekA || !weekB) {
                return false;
            }
            if (weekA?.index_week_id && weekB?.index_week_id) {
                return weekA.index_week_id === weekB.index_week_id;
            }
            if (weekA?.id && weekB?.id) {
                return weekA.id === weekB.id;
            }
            return moment(weekA.date_start).format('YYYY-MM-DD') === moment(weekB.date_start).format('YYYY-MM-DD')
                && moment(weekA.date_end).format('YYYY-MM-DD') === moment(weekB.date_end).format('YYYY-MM-DD');
        },
        isWeekAssigned(week) {
            for (let i = 0; i < this.dataBookRound.length; i++) {
                const rounds = this.dataBookRound[i] ?? [];
                for (let j = 0; j < rounds.length; j++) {
                    const round = rounds[j];
                    if (this.isSameWeek(week, round?.week) || this.isSameWeek(week, round?.week_1)) {
                        return true;
                    }
                }
            }
            return false;
        },
        async validateData() {
            //this.validationErrors = {};



           /// let week_add = document.getElementById("week_valid");
            if (this.dataPopup.week.length==0){
                alert("Please choose week!");
                return true;
               // week_add.setCustomValidity("Please choose week!");
            }//
            if(this.dataPopup.week.length == 1){
                alert("Please choose 2 weeks!");
                return true;
            }
            if(this.dataPopup.week.length>2){
                alert("Please choose 2 weeks!");
                return true;
            }
            return null;
            // var inpObj = document.getElementById("frm_action_week");
            // if (!inpObj.checkValidity()){
            //     console.log('test=====================');
            //     inpObj.reportValidity();
            //     return true;
            // }
        },
        async validateRemovedWeeksBeforeConfirm() {
            const currentSelectedWeeks = [...(this.dataPopup.week ?? [])];
            const originalWeeks = [...(this.dataPopup.original_week ?? [])];
            const removedWeeks = originalWeeks.filter((week) => !currentSelectedWeeks.some((item) => this.isSameWeek(item, week)));
            if (removedWeeks.length === 0) {
                return null;
            }
            for (let i = 0; i < removedWeeks.length; i++) {
                const week = removedWeeks[i];
                const weekIdentifier = this.getWeekIdentifier(week);
                const visitList = (this.visitRecords ?? []).filter((visit) => {
                    const visitIdentifier = this.getWeekIdentifier({
                        index_week_id: visit?.index_week_id,
                        date_start: visit?.visit_start,
                        date_end: visit?.visit_end
                    });
                    return visitIdentifier === weekIdentifier;
                });
                const blockedVisit = visitList.find((visit) => visit?.status !== 'ST001' || `${visit?.type ?? '1'}` !== '1');
                console.log('blockedVisit:', blockedVisit);
                if (blockedVisit) {
                    const weekLabel = week?.week_number ? `Week ${week.week_number}` : 'This week';
                    return `${weekLabel} cannot be changed because it is not eligible for removal.`;
                }
            }
            return null;
        },
        async confirmPopup() {
            if (await this.validateData()) {
                this.$commonFuction.is_loading(false);
                return
            }
            const weekChangeError = await this.validateRemovedWeeksBeforeConfirm();
            if (weekChangeError) {
                this.$toast.add({
                    severity: 'warn',
                    summary: 'Warning',
                    detail: weekChangeError,
                    life: 3000
                });
                return;
            }
            this.dataBookRound.map(m => {
                var dataF = m.filter(f => f.part_id == this.dataPopup.part_id && f.ordinal == this.dataPopup.ordinal && f.round == this.dataPopup.round);
                if (dataF.length > 0) {
                    var index = m.indexOf(dataF[0]);
                    var list_week = [];
                    var week_imtem_tmp = null;
                    var week_item = null;
                    var week_item_1 = null;
                    for (let i = 0; i < this.dataPopup.week.length; i++) {
                        var weekItem = this.normalizeWeek(this.dataPopup.week[i]);
                       // week_item = weekItem;
                        if (i == 0) {
                            week_imtem_tmp = weekItem;
                           list_week.push(weekItem);
                        } else {
                            var date_start_check = moment(week_imtem_tmp.date_start).format('YYYYMMDD'); 
                            var date_start_check_1 = moment(weekItem.date_start).format('YYYYMMDD'); 
                            if(parseInt(date_start_check) > parseInt(date_start_check_1)){
                                
                                list_week.unshift(weekItem);
                                week_item = weekItem
                                week_item_1 = week_imtem_tmp;
                            }else{
                                week_item = week_imtem_tmp;
                                week_item_1 = weekItem;
                                //list_week.push(weekItem);
                            }
                        }
                    }
                    dataF[0].week = week_item;
                    dataF[0].week_1 = week_item_1;
                    dataF[0].original_week = dataF[0].original_week ?? this.dataPopup.original_week[0] ?? null;
                    dataF[0].original_week_1 = dataF[0].original_week_1 ?? this.dataPopup.original_week[1] ?? null;
                    //dataF[0].week = this.dataPopup.week;
                    dataF[0].status = "ST002";
                    dataF[0].is_new = true;
                    console.log("dataF[0]", dataF[0]);
                    m.splice(index, 1, dataF[0]);
                }
            });
            this.dataPopup = {
                id: null,
                ordinal: null,
                part_id: null,
                uid: null,
                round: null,
                part: {
                    part_number: null,
                    name: null,
                },
                week: [],
                original_week: []
            };
            this.previousPopupWeeks = [];
            this.$emit("updateMatrix", this.dataBookRound);
            this.emitMaintenanceUpdate();
            this.showPopup = false;
            await this.getVisitRecords();
        },
        async toggleMaintenance(week, event) {
            const checked = event?.target?.checked === true;
            const currentKey = this.getWeekKey(week);
            const listMaintenance = [...(this.maintenanceVisits ?? [])];
            const currentIndex = listMaintenance.findIndex((item) => this.getWeekKey(item) === currentKey);

            if (checked) {
                const payload = {
                    ...(currentIndex >= 0 ? listMaintenance[currentIndex] : {}),
                    index_week_id: week?.index_week_id ?? null,
                    week_number: week?.week_number ?? null,
                    visit_start: week?.date_start ?? week?.visit_start ?? null,
                    visit_end: week?.date_end ?? week?.visit_end ?? null,
                    is_maintenance: true
                };
                if (currentIndex >= 0) {
                    listMaintenance.splice(currentIndex, 1, payload);
                } else {
                    listMaintenance.push(payload);
                }
            } else if (currentIndex >= 0) {
                listMaintenance.splice(currentIndex, 1);
            }

            this.maintenanceVisits = listMaintenance;
            this.emitMaintenanceUpdate();
            await this.getListWeek();
        },
        async getListIdWeekNotUse(list_id_not=[]) {
            const list_index_week = [];
            for (let i = 0; i < this.dataBookRound.length; i++) {
                const e = this.dataBookRound[i];
                for (let j = 0; j < e.length; j++) {
                    const element = e[j];
                    if (element?.week?.index_week_id) {
                        list_index_week.push(element.week.index_week_id);
                    }
                    if (element?.week_1?.index_week_id) {
                        list_index_week.push(element.week_1.index_week_id);
                    }
                }
            }
            for (let i = 0; i < this.maintenanceVisits.length; i++) {
                const maintenanceItem = this.maintenanceVisits[i];
                if (maintenanceItem?.is_maintenance && maintenanceItem?.index_week_id) {
                    list_index_week.push(maintenanceItem.index_week_id);
                }
            }
            const list_remove = (list_id_not ?? []).filter(Boolean);
            return [...new Set(list_index_week.filter(Boolean))].filter((item) => list_remove.indexOf(item) === -1);
        },
        async getListWeek(list_id_not_remove=[]) {
            if (!this.property?.id) {
                this.listWeek = [];
                return;
            }
            var where_key = {
                property_id: {_eq: this.property?.id}
            }
            var list_id_not = await this.getListIdWeekNotUse(list_id_not_remove);
            if (list_id_not.length > 0) {
                where_key.index_week_id = {_nin: list_id_not}
            }
            if (this.mode == 'edit') {
                where_key.booking_id = {_eq: this.booking_id}
            }
            let {data} = await this.$apollo.query({
                query: DataServices.getList('property_week',{"fields" : `id index_week_id week_number date_start date_end booking_round{id} booking_round_1{id}`}),
                variables: {
                    where_key: where_key,
                    orderBy:[{date_start : 'asc'}]
                },
                fetchPolicy: "network-only"
            })
            var list = data[Object.keys(data)];
            var list_week = [];
            // console.log("list===",list);
            for (let i = 0; i < list.length; i++) {
                const e = list[i];
                if ( !(e?.booking_round?.id || e?.booking_round_1?.id) ) {
                    list_week.push(
                        {
                            id : e.id,
                            index_week_id: e.index_week_id,
                            week_number: e.week_number, 
                            date_start: e.date_start,
                            date_end: e.date_end,
                            name: `Week ${e.week_number} (${this.getFilterDate(e.date_start)} - ${this.getFilterDate(e.date_end)})`});
                }
            }
            console.log("list_week", list_week);
            this.listWeek = list_week
        },
        async getMaintenanceVisits() {
            if (!this.property?.id) {
                this.maintenanceVisits = [];
                this.visitRecords = [];
                return;
            }
            const where_key = {
                deleted: {_eq: false},
                property_id: {_eq: this.property?.id},
                is_maintenance: {_eq: true},
            };
            if (Array.isArray(this.propertyWeeks) && this.propertyWeeks.length > 0) {
                const firstWeek = this.propertyWeeks[0];
                const lastWeek = this.propertyWeeks[this.propertyWeeks.length - 1];
                where_key.visit_start = {_gte: moment(firstWeek.date_start).format('YYYY-MM-DD')};
                where_key.visit_end = {_lte: moment(lastWeek.date_end).format('YYYY-MM-DD')};
            }
            let {data} = await this.$apollo.query({
                query: DataServices.getList('visit',{"fields" : `id index_week_id week_number visit_start visit_end is_maintenance`}),
                variables: {
                    where_key,
                    orderBy:[{visit_start : 'asc'}]
                },
                fetchPolicy: "network-only"
            });
            this.maintenanceVisits = data[Object.keys(data)] ?? [];
            await this.getVisitRecords();
            this.emitMaintenanceUpdate();
        },
        async showPopupChooseDate(data, part) {
            console.log("dataaaaa", data);
            if (this.mode != 'add' && ((data?.week || data?.week_1) || ['ST001', 'ST003'].includes(data?.status) || data?.is_new)) {
                var week =[];
                var original_week = [];
                var list_week_not_remove = [];
                if (data?.week && data?.week_1) {
                    week.push(this.normalizeWeek({
                        id: data.week.id,
                        index_week_id: data.week.index_week_id,
                        week_number: data.week.week_number,
                        date_start: data.week.date_start,
                        date_end: data.week.date_end,
                        name: `Week ${data.week.week_number} (${this.getFilterDate(data.week.date_start)} - ${this.getFilterDate(data.week.date_end)})`,
                        week: data.week
                    }));
                    list_week_not_remove.push(data.week.index_week_id);
                    original_week.push(this.normalizeWeek({
                        id: data.week.id,
                        index_week_id: data.week.index_week_id,
                        week_number: data.week.week_number,
                        date_start: data.week.date_start,
                        date_end: data.week.date_end,
                        name: `Week ${data.week.week_number} (${this.getFilterDate(data.week.date_start)} - ${this.getFilterDate(data.week.date_end)})`
                    }));
                    week.push(this.normalizeWeek({
                        id: data.week_1.id,
                        index_week_id: data.week_1.index_week_id,
                        week_number: data.week_1.week_number,
                        date_start: data.week_1.date_start,
                        date_end: data.week_1.date_end,
                        name: `Week ${data.week_1.week_number} (${this.getFilterDate(data.week_1.date_start)} - ${this.getFilterDate(data.week_1.date_end)})`,
                        week: data.week_1
                    }));
                    list_week_not_remove.push(data.week_1.index_week_id);
                    original_week.push(this.normalizeWeek({
                        id: data.week_1.id,
                        index_week_id: data.week_1.index_week_id,
                        week_number: data.week_1.week_number,
                        date_start: data.week_1.date_start,
                        date_end: data.week_1.date_end,
                        name: `Week ${data.week_1.week_number} (${this.getFilterDate(data.week_1.date_start)} - ${this.getFilterDate(data.week_1.date_end)})`
                    }));
                } 
                await this.getListWeek(list_week_not_remove);
                // var week =  data?.week ? {
                //     id: data.week?.id,
                //     name: `Week ${data.week.week_number} - ${data.week.week_number + 1} (${this.getFilterDate(data.week.date_start)} - ${this.getFilterDate(data.week.date_end)})`,
                //     week: data.week
                // } : null
                this.showPopup = true;
                this.dataPopup = {
                    id: data?.id,
                    ordinal: data.ordinal,
                    part_id: data.part_id,
                    uid: data?.uid ?? part?.user?.id ?? null,
                    round: data.round,
                    part: {
                        part_number: part.part,
                        name: `${part.user.fullname} - ${part.user.email}`,
                    },
                    week: week,
                    original_week: original_week
                }
                this.previousPopupWeeks = [...week];
            }
        },
        getFilterDate(date) {
            return moment.tz(date, this.time_zone_local).format("LL");
        },
        mapDataFormat() {
            var dataBookingRound = [];
            if (this.dataBookRound.length > 0 && this.dataBook.length > 0) {
                return Promise.all(
                    this.dataArr.map((m, ind)=> {
                        var tmp = [];
                        // for (let i =0; i < this.dataArr.length; i++) {
                        this.dataArr.map((n, i)=> {
                            if (this.dataBookRound[ind] && this.dataBookRound[ind][i]) {
                                tmp.push(this.dataBookRound[ind][i]);
                            } else {
                                let a = m - i + this.dataArr.length;
                                if (a > this.dataArr.length) {
                                    a = a - this.dataArr.length;
                                }
                                tmp.push({ordinal: a, part_id: this?.dataMatrix[ind]?.id, round: (i+1)});
                            }
                        });
                        dataBookingRound.push(tmp);
                    })
                ).then(() => {
                    console.log("dataBookingRound", dataBookingRound);
                    console.log("this.dataBookingRound", this.dataBookRound);
                    var is_same = (dataBookingRound.length == this.dataBookRound.length) && this.dataBookRound.every(function(element, index) {
                        return element === dataBookingRound[index];
                    })
                    if (!is_same) {
                        this.$emit("updateMatrix", dataBookingRound);
                    }
                })
            }
        },
    }
};
</script>

<style lang="scss">
    .matrix-layout {
        display: flex;
        gap: 32px;
        align-items: flex-start;
        width: 100%;
    }
    .matrix-table-wrap {
        flex: 2 1 0;
        min-width: 0;
        overflow-x: auto;
    }
    #matrix-table {
        width: 100%;
        min-width: 680px;
    }
    .week-not-chosen {
        flex: 1 1 0;
        min-width: 0;
        width: 100%;
    }
    .week-not-chosen-table-wrap {
        width: 100%;
        max-height: 70vh;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .week-not-chosen-table {
        width: 100%;
        border-collapse: collapse;
        th, td {
            border: 1px solid #EAEAEA;
            padding: 16px;
            vertical-align: middle;
        }
        th {
            background-color: #F3F4F7;
            text-align: center;
            position: sticky;
            top: 0;
            z-index: 1;
        }
        th:first-child,
        td:first-child {
            width: 70%;
        }
        th:last-child,
        td:last-child {
            width: 30%;
            text-align: center;
        }
    }
    .maintenance-cell {
        text-align: center;
    }
    .maintenance-cell input[type="checkbox"] {
        width: 16px;
        height: 16px;
        accent-color: #1D76BC;
        margin: 0 auto;
        display: block;
    }
    .empty-week-text {
        text-align: center;
        color: #6c757d;
    }
    #matrix-table {
        td {
            width: 127px;
            min-height: 127px;
            height: auto;
            border: 1px solid #EAEAEA;
            text-align: center;
            color: #000;
            padding: 20px 5px;
            cursor: pointer;
        }
    }
    .head-color, .body-color {
        background-color: #F3F4F7;
    }
    .head-color{
        font-weight: bold;
    }
    .head-color-blank, .head-color {
        height: 57px !important;
    }
    .head-color-blank {
        border: none !important;
    }
    .vs__dropdown-menu {
        width: 90%;
        padding-bottom: 3em !important;
    }
    .box_select-maxtrict{
       .vs__dropdown-menu {
        width: 100% !important;
    }
    }
    .matrix-week-select {
        .vs__deselect,
        .vs__clear {
            display: none !important;
        }
    }
    @media screen and (max-width: 1200px) {
        .matrix-layout {
            flex-direction: column;
        }
        .matrix-table-wrap,
        .week-not-chosen {
            width: 100%;
        }
    }
</style>
